// Generated by scripts/build-ui-icons.mjs.
export { Target as default } from "../ui/glyphs-7";
